export default __webpack_public_path__ + "static/media/pricing-card-icon.b49c8dfd.JPG";